
@switch ((geneticStatus$ | async)?.pipeline_type) {
  @case (geneticFileStatuses.UPLOADED) {
    <div class="chart chart_info">
      <div class="chart-content">
        <div class="b-flow__text info-caption">No reliable data</div>
        <div class="b-flow__text info-text">
          We find uploaded files, but none of them were correct. Please, try to upload another one
        </div>
        <div class="info-image-wrap">
          <img class="info-image" src="/assets/images/genetics/not-reliable.svg" alt="">
        </div>
      </div>
    </div>
  }
  @case (geneticFileStatuses.CONVERTED) {
    <div class="chart chart_info">
      <div class="chart-content">
        <div class="b-flow__text info-caption">Processing your data</div>
        <div class="b-flow__text info-text">
          We checked your files. Now we are analysing them. Please, return in few minutes to see how genes influence your brain
        </div>
        <div class="info-image-wrap">
          <img class="info-image" src="/assets/images/genetics/in-analysis.svg" alt="">
        </div>
      </div>
    </div>
  }
  @case (geneticFileStatuses.EXTRACTED) {
    @if ((loadGeneticsProgress$ | async) === progressStatuses.SUCCEED) {
      <div
        echarts
        [options]="actualChartConfig$ | async"
        class="chart"
        (chartClick)="chartClick($event)"
      ></div>
    } @else {
      <div class="chart chart_loading">
        <mat-spinner></mat-spinner>
      </div>
    }
    <ng-template #loading>
      <div class="chart chart_loading">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>
  }
}
